(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('@babel/runtime/helpers/defineProperty'), require('redux'), require('lodash/isNil'), require('lodash/flowRight'), require('react-redux'), require('react'), require('@babel/runtime/helpers/classCallCheck'), require('@babel/runtime/helpers/createClass'), require('@babel/runtime/helpers/possibleConstructorReturn'), require('@babel/runtime/helpers/getPrototypeOf'), require('@babel/runtime/helpers/inherits'), require('react-is'), require('lodash/omit'), require('lodash/camelCase'), require('lodash/intersection'), require('react-fast-compare'), require('deepmerge'), require('lodash/memoize')) :
  typeof define === 'function' && define.amd ? define(['exports', '@babel/runtime/helpers/defineProperty', 'redux', 'lodash/isNil', 'lodash/flowRight', 'react-redux', 'react', '@babel/runtime/helpers/classCallCheck', '@babel/runtime/helpers/createClass', '@babel/runtime/helpers/possibleConstructorReturn', '@babel/runtime/helpers/getPrototypeOf', '@babel/runtime/helpers/inherits', 'react-is', 'lodash/omit', 'lodash/camelCase', 'lodash/intersection', 'react-fast-compare', 'deepmerge', 'lodash/memoize'], factory) :
  (global = global || self, factory(global['@flopflip/react-redux'] = {}, global._defineProperty, global.redux, global.isNil, global.flowRight, global['react-redux'], global.React, global._classCallCheck, global._createClass, global._possibleConstructorReturn, global._getPrototypeOf, global._inherits, global.reactIs, global.omit, global.camelCase, global.intersection, global.isEqual, global.merge, global.memoize));
}(this, (function (exports, _defineProperty, redux, isNil, flowRight, reactRedux, React, _classCallCheck, _createClass, _possibleConstructorReturn, _getPrototypeOf, _inherits, reactIs, omit, camelCase, intersection, isEqual, merge, memoize) { 'use strict';

  _defineProperty = _defineProperty && _defineProperty.hasOwnProperty('default') ? _defineProperty['default'] : _defineProperty;
  isNil = isNil && isNil.hasOwnProperty('default') ? isNil['default'] : isNil;
  flowRight = flowRight && flowRight.hasOwnProperty('default') ? flowRight['default'] : flowRight;
  React = React && React.hasOwnProperty('default') ? React['default'] : React;
  _classCallCheck = _classCallCheck && _classCallCheck.hasOwnProperty('default') ? _classCallCheck['default'] : _classCallCheck;
  _createClass = _createClass && _createClass.hasOwnProperty('default') ? _createClass['default'] : _createClass;
  _possibleConstructorReturn = _possibleConstructorReturn && _possibleConstructorReturn.hasOwnProperty('default') ? _possibleConstructorReturn['default'] : _possibleConstructorReturn;
  _getPrototypeOf = _getPrototypeOf && _getPrototypeOf.hasOwnProperty('default') ? _getPrototypeOf['default'] : _getPrototypeOf;
  _inherits = _inherits && _inherits.hasOwnProperty('default') ? _inherits['default'] : _inherits;
  omit = omit && omit.hasOwnProperty('default') ? omit['default'] : omit;
  camelCase = camelCase && camelCase.hasOwnProperty('default') ? camelCase['default'] : camelCase;
  intersection = intersection && intersection.hasOwnProperty('default') ? intersection['default'] : intersection;
  isEqual = isEqual && isEqual.hasOwnProperty('default') ? isEqual['default'] : isEqual;
  merge = merge && merge.hasOwnProperty('default') ? merge['default'] : merge;
  memoize = memoize && memoize.hasOwnProperty('default') ? memoize['default'] : memoize;

  function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
  // Actions
  var UPDATE_FLAGS = '@flopflip/flags/update';
  var initialState = {}; // Reducer

  var reducer = function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 ? arguments[1] : undefined;

    switch (action.type) {
      case UPDATE_FLAGS:
        return _objectSpread({}, state, {}, action.payload.flags);

      default:
        return state;
    }
  };
  var createReducer = function createReducer() {
    var preloadedState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    return function () {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : preloadedState;
      var action = arguments.length > 1 ? arguments[1] : undefined;
      return reducer(state, action);
    };
  }; // Action Creators

  var updateFlags = function updateFlags(flags) {
    return {
      type: UPDATE_FLAGS,
      payload: {
        flags: flags
      }
    };
  }; // Selectors

  var selectFlags = function selectFlags(state) {
    var _state$STATE_SLICE$fl;

    return (_state$STATE_SLICE$fl = state[STATE_SLICE].flags) !== null && _state$STATE_SLICE$fl !== void 0 ? _state$STATE_SLICE$fl : {};
  };
  var selectFlag = function selectFlag(flagName) {
    return function (state) {
      var allFlags = selectFlags(state);
      var flagValue = allFlags[flagName];
      return isNil(flagValue) ? false : flagValue;
    };
  };

  function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

  // Actions
  var UPDATE_STATUS = '@flopflip/status/update';
  var initialState$1 = {
    isReady: false
  }; // Reducer

  var reducer$1 = function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState$1;
    var action = arguments.length > 1 ? arguments[1] : undefined;

    switch (action.type) {
      case UPDATE_STATUS:
        return _objectSpread$1({}, state, {}, action.payload.status);

      default:
        return state;
    }
  };

  var updateStatus = function updateStatus(status) {
    return {
      type: UPDATE_STATUS,
      payload: {
        status: status
      }
    };
  };

  var flopflipReducer = redux.combineReducers({
    flags: reducer,
    status: reducer$1
  });
  var createFlopflipReducer = function createFlopflipReducer() {
    var preloadedState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return redux.combineReducers({
      flags: createReducer(preloadedState),
      status: reducer$1
    });
  };

  function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
  function createFlopFlipEnhancer(adapter, adapterArgs) {
    return function (next) {
      return function () {
        var store = next.apply(void 0, arguments);
        adapter.configure(_objectSpread$2({}, adapterArgs, {
          // NOTE: This is like `bindActionCreators` but the bound action
          // creators are renamed to fit the adapter API and conventions.
          onFlagsStateChange: function onFlagsStateChange(flags) {
            store.dispatch(updateFlags(flags));
          },
          onStatusStateChange: function onStatusStateChange(status) {
            store.dispatch(updateStatus(status));
          }
        }));
        return store;
      };
    };
  }

  var STATE_SLICE = '@flopflip';

  function warning(condition, message) {
    {
      if (condition) {
        return;
      }

      var text = "Warning: " + message;

      if (typeof console !== 'undefined') {
        console.warn(text);
      }

      try {
        throw Error(text);
      } catch (x) {}
    }
  }

  var initialReconfigureAdapter = function initialReconfigureAdapter() {
    return undefined;
  };

  var initialAdapterStatus = {
    isReady: false,
    isConfigured: false
  };

  var createAdapterContext = function createAdapterContext(reconfigure, status) {
    return {
      reconfigure: reconfigure !== null && reconfigure !== void 0 ? reconfigure : initialReconfigureAdapter,
      status: status !== null && status !== void 0 ? status : initialAdapterStatus
    };
  };

  var initialAdapterContext = createAdapterContext();
  var AdapterContext = React.createContext(initialAdapterContext);

  var isEmptyChildren = function isEmptyChildren(children) {
    return React.Children.count(children) === 0;
  };

  var ToggleFeature =
  /*#__PURE__*/
  function (_React$PureComponent) {
    _inherits(ToggleFeature, _React$PureComponent);

    function ToggleFeature() {
      _classCallCheck(this, ToggleFeature);

      return _possibleConstructorReturn(this, _getPrototypeOf(ToggleFeature).apply(this, arguments));
    }

    _createClass(ToggleFeature, [{
      key: "render",
      value: function render() {
        if (this.props.untoggledComponent) warning(reactIs.isValidElementType(this.props.untoggledComponent), "Invalid prop 'untoggledComponent' supplied to 'ToggleFeature': the prop is not a valid React component");
        if (this.props.toggledComponent) warning(reactIs.isValidElementType(this.props.toggledComponent), "Invalid prop 'toggledComponent' supplied to 'ToggleFeature': the prop is not a valid React component");

        if (this.props.isFeatureEnabled) {
          if (this.props.toggledComponent) return React.createElement(this.props.toggledComponent);
          if (this.props.children && !isEmptyChildren(this.props.children)) return React.Children.only(this.props.children);
          if (typeof this.props.render === 'function') return this.props.render();
        }

        if (typeof this.props.children === 'function') return this.props.children({
          isFeatureEnabled: this.props.isFeatureEnabled
        });

        if (this.props.untoggledComponent) {
          return React.createElement(this.props.untoggledComponent);
        }

        return null;
      }
    }]);

    return ToggleFeature;
  }(React.PureComponent);

  ToggleFeature.displayName = 'ToggleFeature';
  ToggleFeature.defaultProps = {
    untoggledComponent: null,
    toggledComponent: null,
    render: null,
    children: null
  };

  var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
    var _BaseComponent$displa;

    var previousDisplayName = (_BaseComponent$displa = BaseComponent.displayName) !== null && _BaseComponent$displa !== void 0 ? _BaseComponent$displa : BaseComponent.name;
    return "".concat(hocName, "(").concat(previousDisplayName !== null && previousDisplayName !== void 0 ? previousDisplayName : 'Component', ")");
  };

  var setDisplayName = function setDisplayName(nextDisplayName) {
    return function (BaseComponent) {
      BaseComponent.displayName = nextDisplayName;
      return BaseComponent;
    };
  };

  var omitProps = function omitProps(propsToOmit) {
    return function (Component) {
      var OmitProps = function OmitProps(props) {
        var withoutOmittedProps = omit(props, propsToOmit);
        return React.createElement(Component, withoutOmittedProps);
      };

      {
        return setDisplayName(wrapDisplayName(Component, 'omitProps'))(OmitProps);
      }
    };
  };

  function ownKeys$3(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread$3(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys$3(Object(source), true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys$3(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  function isPropsMapper(mapProps) {
    return typeof mapProps === 'function';
  }

  var withProps = function withProps(mapProps) {
    return function (Component) {
      var EnhancedWithProps = function EnhancedWithProps(ownProps) {
        var enhancedProps = isPropsMapper(mapProps) ? _objectSpread$3({}, ownProps, {}, mapProps(ownProps)) : _objectSpread$3({}, ownProps, {}, mapProps);
        return React.createElement(Component, enhancedProps);
      };

      {
        return setDisplayName(wrapDisplayName(Component, 'withProps'))(EnhancedWithProps);
      }
    };
  };

  var DEFAULT_FLAG_PROP_KEY = 'isFeatureEnabled';
  var DEFAULT_FLAGS_PROP_KEY = 'featureToggles';
  var ALL_FLAGS_PROP_KEY = '@flopflip/flags';

  var getNormalizedFlagName = function getNormalizedFlagName(flagName) {
    return camelCase(flagName);
  };
  /**
   * Given a `flagName` and a `flagVariation`
   * indicating if the given feature should be toggled (turned off).
   *
   * @method isFeatureEnabled
   * @param  {String}    flagName                   The flag name (e.g. signup-v2)
   * @param  {Boolean}   [flagVariation=true]       The variation of the flag defaulting to `true`
   * @return {Boolean}                              Indicator if the flag should be toggled
   */


  var getIsFeatureEnabled = function getIsFeatureEnabled() {
    var flagName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_FLAG_PROP_KEY;
    var flagVariation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var normalizedFlagName = getNormalizedFlagName(flagName);
    warning(normalizedFlagName === flagName, '@flopflip/react: passed flag name does not seem to be normalized which may result in unexpected toggling. Please refer to our readme for more information: https://github.com/tdeekens/flopflip#flag-normalization');
    return function (flags) {
      return flags[normalizedFlagName] === flagVariation;
    };
  };

  var injectFeatureToggle = function injectFeatureToggle(flagName) {
    var propKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_FLAG_PROP_KEY;
    return function (Component) {
      return (// @ts-ignore
        flowRight(withProps(function (ownProps) {
          var flagVariation = ownProps[ALL_FLAGS_PROP_KEY][getNormalizedFlagName(flagName)];
          return _defineProperty({}, propKey, isNil(flagVariation) ? false : flagVariation);
        }), omitProps([ALL_FLAGS_PROP_KEY]))(Component)
      );
    };
  };

  function ownKeys$1$1(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread$1$1(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys$1$1(Object(source), true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys$1$1(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  var defaultAreOwnPropsEqual = function defaultAreOwnPropsEqual(nextOwnProps, ownProps, propKey) {
    var featureFlagProps = ownProps[propKey];
    var remainingProps = omit(ownProps, [propKey]);
    var nextFeatureFlagProps = nextOwnProps[propKey];
    var nextRemainingProps = omit(nextOwnProps, [propKey]);
    return isEqual(featureFlagProps, nextFeatureFlagProps) && isEqual(remainingProps, nextRemainingProps);
  };

  var filterFeatureToggles = function filterFeatureToggles(allFlags, demandedFlags) {
    return intersection(Object.keys(allFlags), demandedFlags).reduce(function (featureToggles, flagName) {
      return _objectSpread$1$1({}, featureToggles, _defineProperty({}, getNormalizedFlagName(flagName), allFlags[getNormalizedFlagName(flagName)]));
    }, {});
  };

  var shouldUpdate = function shouldUpdate(areOwnPropsEqual, propKey) {
    return function (Component) {
      var _class, _temp;

      return _temp = _class =
      /*#__PURE__*/
      function (_React$Component) {
        _inherits(ShouldUpdate, _React$Component);

        function ShouldUpdate() {
          _classCallCheck(this, ShouldUpdate);

          return _possibleConstructorReturn(this, _getPrototypeOf(ShouldUpdate).apply(this, arguments));
        }

        _createClass(ShouldUpdate, [{
          key: "shouldComponentUpdate",
          value: function shouldComponentUpdate(nextProps) {
            return typeof areOwnPropsEqual === 'function' ? !areOwnPropsEqual(this.props, nextProps, propKey) : true;
          }
        }, {
          key: "render",
          value: function render() {
            return React.createElement(Component, this.props);
          }
        }]);

        return ShouldUpdate;
      }(React.Component), _class.displayName = Component.displayName, _temp;
    };
  };

  var injectFeatureToggles = function injectFeatureToggles(flagNames) {
    var propKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_FLAGS_PROP_KEY;
    var areOwnPropsEqual = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultAreOwnPropsEqual;
    return function (Component) {
      return (// @ts-ignore
        flowRight(withProps(function (props) {
          return _defineProperty({}, propKey, filterFeatureToggles(props[ALL_FLAGS_PROP_KEY], flagNames));
        }), omitProps([ALL_FLAGS_PROP_KEY]), shouldUpdate(areOwnPropsEqual, propKey))(Component)
      );
    };
  };

  var DefaultUntoggledComponent =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(DefaultUntoggledComponent, _React$Component);

    function DefaultUntoggledComponent() {
      _classCallCheck(this, DefaultUntoggledComponent);

      return _possibleConstructorReturn(this, _getPrototypeOf(DefaultUntoggledComponent).apply(this, arguments));
    }

    _createClass(DefaultUntoggledComponent, [{
      key: "render",
      value: function render() {
        return null;
      }
    }]);

    return DefaultUntoggledComponent;
  }(React.Component);

  var branchOnFeatureToggle = function branchOnFeatureToggle() {
    var UntoggledComponent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DefaultUntoggledComponent;
    var flagName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_FLAG_PROP_KEY;
    var flagVariation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    return function (ToggledComponent) {
      var BranchOnFeatureToggle = function BranchOnFeatureToggle(props) {
        if (getIsFeatureEnabled(flagName, flagVariation)(props)) {
          return React.createElement(ToggledComponent, props);
        }

        return React.createElement(UntoggledComponent, props);
      };

      return BranchOnFeatureToggle;
    };
  };

  function ownKeys$2$1(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread$2$1(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys$2$1(Object(source), true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys$2$1(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  var AdapterStates = {
    UNCONFIGURED: 'unconfigured',
    CONFIGURING: 'configuring',
    CONFIGURED: 'configured'
  };

  var isFunctionChildren = function isFunctionChildren(children) {
    return typeof children === 'function';
  };

  var isEmptyChildren$1 = function isEmptyChildren(children) {
    return !isFunctionChildren(children) && React.Children.count(children) === 0;
  };

  var mergeAdapterArgs = function mergeAdapterArgs(previousAdapterArgs, _ref) {
    var nextAdapterArgs = _ref.adapterArgs,
        _ref$options = _ref.options,
        options = _ref$options === void 0 ? {} : _ref$options;
    return options.shouldOverwrite ? nextAdapterArgs : merge(previousAdapterArgs, nextAdapterArgs);
  };

  var ConfigureAdapter =
  /*#__PURE__*/
  function (_React$PureComponent) {
    _inherits(ConfigureAdapter, _React$PureComponent);

    function ConfigureAdapter() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, ConfigureAdapter);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ConfigureAdapter)).call.apply(_getPrototypeOf2, [this].concat(args)));
      _this.adapterState = AdapterStates.UNCONFIGURED;
      _this.pendingAdapterArgs = null;
      _this.state = {
        appliedAdapterArgs: _this.props.adapterArgs
      };

      _this.setAdapterState = function (nextAdapterState) {
        _this.adapterState = nextAdapterState;
      };

      _this.applyAdapterArgs = function (nextAdapterArgs) {
        return (
          /**
           * NOTE:
           *   We can only unset `pendingAdapterArgs` after be actually perform
           *   a batched `setState` otherwise outdated `adapterArgs` as we loose
           *   the `pendingAdapterArgs` as we unset them too early.
           */
          _this.setState(function (prevState) {
            return _objectSpread$2$1({}, prevState, {
              appliedAdapterArgs: nextAdapterArgs
            });
          }, function () {
            _this.pendingAdapterArgs = null;
          })
        );
      };

      _this.reconfigureOrQueue = function (nextAdapterArgs, options) {
        return _this.adapterState === AdapterStates.CONFIGURED && _this.adapterState !== AdapterStates.CONFIGURING ? _this.applyAdapterArgs(mergeAdapterArgs(_this.state.appliedAdapterArgs, {
          adapterArgs: nextAdapterArgs,
          options: options
        })) : _this.setPendingAdapterArgs({
          adapterArgs: nextAdapterArgs,
          options: options
        });
      };

      _this.setPendingAdapterArgs = function (nextReconfiguration) {
        /**
         * NOTE:
         *    The next reconfiguration is merged into the previous
         *    one instead of maintaining a queue.
         *
         *    The first merge with merge with `appliedAdapter` args
         *    to contain the initial state (through property initializer).
         */
        _this.pendingAdapterArgs = mergeAdapterArgs(_this.pendingAdapterArgs || _this.state.appliedAdapterArgs, nextReconfiguration);
      };

      _this.getAdapterArgsForConfiguration = function () {
        return _this.pendingAdapterArgs || _this.state.appliedAdapterArgs;
      };

      _this.handleDefaultFlags = function (defaultFlags) {
        if (Object.keys(defaultFlags).length > 0) {
          _this.props.adapterArgs.onFlagsStateChange(defaultFlags);
        }
      };

      return _this;
    }

    _createClass(ConfigureAdapter, [{
      key: "UNSAFE_componentWillReceiveProps",

      /**
       * NOTE:
       *   This should be UNSAFE_componentWillReceiveProps.
       *   However to maintain compatibility with older and newer versions of React
       *   this can not be prefixed with UNSAFE_.
       *
       *   For the future this should likely happen in cDU however as `reconfigureOrQueue`
       *   may trigger a `setState` it might have unexpected side-effects (setState-loop).
       *   Maybe some more substancial refactor would be needed.
       */
      value: function UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.adapterArgs !== this.props.adapterArgs) {
          /**
           * NOTE:
           *   The component might receive `adapterArgs` from `ReconfigureFlopflip`
           *   before it managed to configure. If that occurs the next `adapterArgs`
           *   passed in will overwrite what `ReconfigureFlopflip` passed in before
           *   yieling a loss in configuration.
           *
           *   Whenever however the adapter has configured we want to component to
           *   act in a controleld manner. So that overwriting will occur when the
           *   passed `adapterArgs` change.
           */
          this.reconfigureOrQueue(nextProps.adapterArgs, {
            shouldOverwrite: this.adapterState === AdapterStates.CONFIGURED
          });
        }
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this2 = this;

        if (this.props.defaultFlags) this.handleDefaultFlags(this.props.defaultFlags);

        if (!this.props.shouldDeferAdapterConfiguration) {
          this.setAdapterState(AdapterStates.CONFIGURING);
          return this.props.adapter.configure(this.getAdapterArgsForConfiguration()).then(function () {
            _this2.setAdapterState(AdapterStates.CONFIGURED);

            if (_this2.pendingAdapterArgs) {
              _this2.applyAdapterArgs(_this2.pendingAdapterArgs);
            }
          });
        }
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate() {
        var _this3 = this;
        /**
         * NOTE:
         *    Be careful here to not double configure from `componentDidMount`.
         *    Moreover, cDU will also be invoked from `setState` to `appliedAdapterArgs`.
         *    Hence, avoid calling `setState` within cDU.
         */


        if (!this.props.shouldDeferAdapterConfiguration && this.adapterState !== AdapterStates.CONFIGURED && this.adapterState !== AdapterStates.CONFIGURING) {
          this.setAdapterState(AdapterStates.CONFIGURING);
          return this.props.adapter // NOTE: ESLint otherwise fails for unknown reasons
          // eslint-disable-next-line
          .configure(this.getAdapterArgsForConfiguration()).then(function () {
            _this3.setAdapterState(AdapterStates.CONFIGURED);

            if (_this3.pendingAdapterArgs) {
              _this3.applyAdapterArgs(_this3.pendingAdapterArgs);
            }
          });
        } else if (this.adapterState === AdapterStates.CONFIGURED && this.adapterState !== AdapterStates.CONFIGURING) {
          this.setAdapterState(AdapterStates.CONFIGURING);
          return this.props.adapter // NOTE: ESLint otherwise fails for unknown reasons
          // eslint-disable-next-line
          .reconfigure(this.getAdapterArgsForConfiguration()).then(function () {
            _this3.setAdapterState(AdapterStates.CONFIGURED);
          });
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this4 = this;

        return React.createElement(AdapterContext.Provider, {
          value: createAdapterContext(this.reconfigureOrQueue, this.props.adapterStatus)
        }, function () {
          var isAdapterReady = _this4.props.adapter.getIsReady();

          if (isAdapterReady) {
            if (typeof _this4.props.render === 'function') return _this4.props.render();
          }

          if (isFunctionChildren(_this4.props.children)) return _this4.props.children({
            isAdapterReady: isAdapterReady
          });
          if (_this4.props.children && !isEmptyChildren$1(_this4.props.children)) return React.Children.only(_this4.props.children);
          return null;
        }());
      }
    }]);

    return ConfigureAdapter;
  }(React.PureComponent);

  ConfigureAdapter.defaultProps = {
    shouldDeferAdapterConfiguration: false,
    defaultFlags: {},
    children: null,
    render: null
  };

  var withReconfiguration = function withReconfiguration() {
    var propKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'reconfigure';
    return function (Component) {
      var EnhancedComponent =
      /*#__PURE__*/
      function (_React$PureComponent) {
        _inherits(EnhancedComponent, _React$PureComponent);

        function EnhancedComponent() {
          _classCallCheck(this, EnhancedComponent);

          return _possibleConstructorReturn(this, _getPrototypeOf(EnhancedComponent).apply(this, arguments));
        }

        _createClass(EnhancedComponent, [{
          key: "render",
          value: function render() {
            var _this = this;

            return React.createElement(AdapterContext.Consumer, null, function (_ref) {
              var reconfigure = _ref.reconfigure;
              return React.createElement(Component, Object.assign({}, _this.props, _defineProperty({}, propKey, reconfigure)));
            });
          }
        }]);

        return EnhancedComponent;
      }(React.PureComponent);

      EnhancedComponent.displayName = wrapDisplayName(Component, 'withReconfiguration');
      return EnhancedComponent;
    };
  };

  var ReconfigureAdapter =
  /*#__PURE__*/
  function (_React$PureComponent) {
    _inherits(ReconfigureAdapter, _React$PureComponent);

    function ReconfigureAdapter() {
      _classCallCheck(this, ReconfigureAdapter);

      return _possibleConstructorReturn(this, _getPrototypeOf(ReconfigureAdapter).apply(this, arguments));
    }

    _createClass(ReconfigureAdapter, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        return this.props.reconfigure({
          user: this.props.user
        }, {
          shouldOverwrite: this.props.shouldOverwrite
        });
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate() {
        return this.props.reconfigure({
          user: this.props.user
        }, {
          shouldOverwrite: this.props.shouldOverwrite
        });
      }
    }, {
      key: "render",
      value: function render() {
        return this.props.children ? React.Children.only(this.props.children) : null;
      }
    }]);

    return ReconfigureAdapter;
  }(React.PureComponent);

  ReconfigureAdapter.displayName = 'ReconfigureAdapter';
  ReconfigureAdapter.defaultProps = {
    shouldOverwrite: false,
    children: null
  };
  var reconfigureAdapter = withReconfiguration()(ReconfigureAdapter);

  function useAdapterReconfiguration() {
    if (typeof React.useContext === 'function') {
      var adapterContext = React.useContext(AdapterContext);
      return adapterContext.reconfigure;
    }

    throw new Error('React hooks are not available in your currently installed version of React.');
  }

  var mapStateToProps = function mapStateToProps(state, ownProps) {
    var _state$STATE_SLICE$fl;

    return {
      isFeatureEnabled: getIsFeatureEnabled(ownProps.flag, ownProps.variation)((_state$STATE_SLICE$fl = state[STATE_SLICE].flags) !== null && _state$STATE_SLICE$fl !== void 0 ? _state$STATE_SLICE$fl : {})
    };
  };
  var toggleFeature = flowRight(setDisplayName(ToggleFeature.displayName), reactRedux.connect(mapStateToProps))(ToggleFeature);

  var mapStateToProps$1 = function mapStateToProps(state) {
    return _defineProperty({}, ALL_FLAGS_PROP_KEY, selectFlags(state));
  };
  var injectFeatureToggle$1 = (function (flagName, propKey) {
    return function (Component) {
      return flowRight(setDisplayName(wrapDisplayName(Component, 'injectFeatureToggle')), // @ts-ignore
      reactRedux.connect(mapStateToProps$1), injectFeatureToggle(flagName, propKey))(Component);
    };
  });

  var mapStateToProps$2 = function mapStateToProps(state) {
    return _defineProperty({}, ALL_FLAGS_PROP_KEY, selectFlags(state));
  };
  var injectFeatureToggles$1 = (function (flagNames, propKey, areOwnPropsEqual) {
    return function (Component) {
      return flowRight(setDisplayName(wrapDisplayName(Component, 'injectFeatureToggles')), // @ts-ignore
      reactRedux.connect(mapStateToProps$2), injectFeatureToggles(flagNames, propKey, areOwnPropsEqual))(Component);
    };
  });

  var branchOnFeatureToggle$1 = (function (_ref, UntoggledComponent) {
    var flag = _ref.flag,
        variation = _ref.variation;
    return function (Component) {
      return flowRight(setDisplayName(wrapDisplayName(Component, 'branchOnFeatureToggle')), injectFeatureToggle$1(flag), branchOnFeatureToggle(UntoggledComponent, DEFAULT_FLAG_PROP_KEY, variation))(Component);
    };
  });

  function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$4(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
  var createAdapterArgs = memoize(function (adapterArgs, eventHandlers) {
    return _objectSpread$4({}, adapterArgs, {}, eventHandlers);
  });
  var Configure =
  /*#__PURE__*/
  function (_React$PureComponent) {
    _inherits(Configure, _React$PureComponent);

    function Configure() {
      _classCallCheck(this, Configure);

      return _possibleConstructorReturn(this, _getPrototypeOf(Configure).apply(this, arguments));
    }

    _createClass(Configure, [{
      key: "render",
      value: function render() {
        return React.createElement(ConfigureAdapter, {
          adapter: this.props.adapter,
          adapterArgs: createAdapterArgs(this.props.adapterArgs, {
            onFlagsStateChange: this.props.handleUpdateFlags,
            onStatusStateChange: this.props.handleUpdateStatus
          }),
          defaultFlags: this.props.defaultFlags,
          shouldDeferAdapterConfiguration: this.props.shouldDeferAdapterConfiguration
        }, this.props.children);
      }
    }]);

    return Configure;
  }(React.PureComponent);
  Configure.displayName = 'ConfigureFlopflip';
  Configure.defaultProps = {
    defaultFlags: {},
    shouldDeferAdapterConfiguration: false
  };
  var mapDispatchToProps = {
    handleUpdateStatus: updateStatus,
    handleUpdateFlags: updateFlags
  };
  var configure = reactRedux.connect(null, mapDispatchToProps)(Configure);

  var version = '9.1.5';

  exports.ConfigureFlopFlip = configure;
  exports.FLOPFLIP_STATE_SLICE = STATE_SLICE;
  exports.ReconfigureFlopFlip = reconfigureAdapter;
  exports.ToggleFeature = toggleFeature;
  exports.UPDATE_FLAGS = UPDATE_FLAGS;
  exports.UPDATE_STATUS = UPDATE_STATUS;
  exports.branchOnFeatureToggle = branchOnFeatureToggle$1;
  exports.createFlopFlipEnhancer = createFlopFlipEnhancer;
  exports.createFlopflipReducer = createFlopflipReducer;
  exports.flopflipReducer = flopflipReducer;
  exports.injectFeatureToggle = injectFeatureToggle$1;
  exports.injectFeatureToggles = injectFeatureToggles$1;
  exports.selectFeatureFlag = selectFlag;
  exports.selectFeatureFlags = selectFlags;
  exports.useAdapterReconfiguration = useAdapterReconfiguration;
  exports.version = version;

  Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=@flopflip-react-redux.umd.js.map
